<content>
    <form [formGroup]="sendInvitationForm" [ngClass]="{'show-error':showError}">
        <div class="entry-4-modal">
            <label>{{'usuarios.etiquetador.modal.etiquetador' | translate}}</label>
            <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="sendInvitationForm.get('etiquetador')" [placeHolder]="false" [disabled]="disabledEtiquetadores">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.etiquetador.modal.email' | translate}} *</label>
            <input type="email" formControlName="email">
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.etiquetador.modal.zonaHoraria' | translate}} *</label>
            <app-filterable-list class="shorter-list" [itemsList]="timezones" [selectedItem]="sendInvitationForm.get('msTimeZoneId')" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.etiquetador.modal.idioma' | translate}} *</label>
            <app-filterable-list class="shorter-list" [itemsList]="idiomas" [selectedItem]="sendInvitationForm.get('idiomaId')" [placeHolder]="false"></app-filterable-list>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="send()">{{'global.enviar' | translate }}</button>
</footer>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
  